import classNames from 'classnames';
import { IconMessage2 } from '@/features/icons';
import formatLargeNumber from '@/utils/string-helpers/format-large-number';
import { useGetComments } from '../../_utils/use-get-comments';
import usePDPData from '../../_utils/use-pdp-data';
interface Props {
  isLinkToCommentSection?: boolean;
}
function CommentsCounter({
  isLinkToCommentSection
}: Props) {
  const {
    data
  } = usePDPData();
  const {
    data: comments
  } = useGetComments(data?.id || '', 1);
  const handleScrollToComments = () => {
    if (!isLinkToCommentSection) return;
    const commentsOffset = document.getElementById('comments')?.offsetTop;
    if (!commentsOffset) return;
    window.scrollTo({
      behavior: 'smooth',
      top: commentsOffset - 20
    });
  };
  if (!comments?.totalCount) return null;
  return <button onClick={handleScrollToComments} type='button' className={classNames('flex items-center gap-1 text-text-mediumGray lg:gap-1.5', {
    'cursor-default': !isLinkToCommentSection
  })} data-sentry-component="CommentsCounter" data-sentry-source-file="comments-counter.tsx">
            <IconMessage2 className='h-4 w-4 lg:h-5 lg:w-5' data-sentry-element="IconMessage2" data-sentry-source-file="comments-counter.tsx" />
            <span className='text-caption-12 lg:text-body-14'>{formatLargeNumber(comments.totalCount)} دیدگاه</span>
        </button>;
}
export default CommentsCounter;